module.exports = __webpack_public_path__ + "static/self_portrait-9c66e9c5712455c5feaaeeb80840003e.png";